import type { AxiosResponse } from 'axios'
import { endpoints } from 'constants/endpoints'
import { env } from 'constants/env'
import api from 'services/api'

import { toNDHistoryParamsApi } from './adapter'
import type {
  JustificationNDResponse,
  JustificationVeredict,
  NDPayload,
  NDResponseType,
  QueryType,
  ResponseNDVeredict,
} from './interface'

// TODO: Export endpoints from this file to endpoints.ts file

export const downloadCurrentNDReport = async (payload: NDPayload) => {
  const response: AxiosResponse<ArrayBuffer> = await api.post(
    '/gerir-ov/negociacao_diferenciada/exportar',
    payload,
    { responseType: 'arraybuffer' },
  )
  return response.data
}

export const requestNDHistory = async (quotaMonth: string) => {
  const response = await api.post(
    endpoints.nd.requestHistory,
    {},
    { params: toNDHistoryParamsApi(quotaMonth) },
  )
  return response
}

export const NDFilter = async (payload: NDPayload, query: QueryType) => {
  return api.post<NDResponseType>(
    `gerir-ov/negociacao-diferenciada/listar?Paginas=${query.page}&Linhas=${query.limit}`,
    payload,
  )
}

export const getJustificationND = async (ovNumber: string) => {
  const response = await api.get<JustificationNDResponse[]>(
    `${env.manageOVBasePath}/${ovNumber}/obter-dados-justificativa-negociacao-diferenciada`,
  )

  return response.data
}

export const EmptyNDPayload = {
  causas: [],
  codigosEquipeVenda: [],
  codigosRegiaoVenda: [],
  codigosSapCliente: [],
  hierarquiaCliente: false,
  material: '',
  mesesCota: [],
  numerosOrdemVenda: [],
  numerosOrdemVendaSap: [],
  razoesSociaisCliente: [],
  statusAprovacao: [],
  tiposMaterial: [],
  tiposOrdemVenda: [],
}

export const getNDList = async (payload: NDPayload, query: QueryType) => {
  const response = await api.post(
    `${env.manageOVBasePath}/negociacao-diferenciada/listar?Paginas=${
      query.page
    }&Linhas=${query.limit}&parametroOrdenacao=${query.column || ''}&ordenarCrescente=${
      query.isCrescent || false
    }`,
    payload !== ({} as NDPayload) ? payload : EmptyNDPayload,
  )

  return response.data
}

export const setJustificationVeredict = async (body: JustificationVeredict) => {
  const response = await api.post<ResponseNDVeredict[]>(
    `${env.manageOVBasePath}/negociacao-diferenciada/analisar`,
    body,
  )

  return response.data
}

export const getListaAnoMesCota = async () => {
  const response = await api.get(`${env.commercialStructure}/${env.apiVersion}/ListaAnoMesCota`)

  return response.data.Result
}
